<mat-tab-group class="tabs__section" #tabs>
  <mat-tab label="Search Filter">
    <app-search-filter [objectStore]="objectStore$ | async" [disabled]="loading$ | async" (search)="search($event)">
    </app-search-filter>
  </mat-tab>
  <mat-tab label="Search Results">
    <app-search-results (DownloadResults)="download($event)" [fullTextResults]="fullTextResults"
      [resultsExceeded]="resultsExceeded" [documentIds]="documentIds" [objectStore]="objectStore$ | async">
    </app-search-results>
  </mat-tab>
</mat-tab-group>



<div *ngIf="loading$ | async" class="spinner">
  <mat-spinner></mat-spinner>
</div>
